module.exports = __webpack_public_path__ + "img/ysc.06efc755.png";